import { useNavigate } from 'react-router-dom';

interface LookbookSectionProps {
  images: string[];
}

export default function LookbookSection({ images }: LookbookSectionProps) {
  const navigate = useNavigate();

  return (
    <div id="lookbook" className="pt-8">
      <div className="flex items-center justify-between">
        <h2 className="text-lg md:text-xl font-bold text-[#121B35]">브랜드 룩북</h2>
        <button
          onClick={() => navigate('lookbook')}
          className="text-[13px] md:text-sm text-[#536079] hover:text-[#121B35] transition-colors flex items-center gap-1 whitespace-nowrap"
        >
          룩북 전체 보기
          <i className="ri-arrow-right-s-line" />
        </button>
      </div>

      {/* Mobile */}
      <div className="lg:hidden mt-4">
        <div className="rounded-2xl overflow-hidden aspect-[16/9]">
          <img src={images?.[0]} alt="룩북 대표" className="w-full h-full object-cover" />
        </div>
        <div className="grid grid-cols-2 gap-2 mt-2">
          {images?.slice(1).map((src, i) => (
            <div key={i} className="rounded-2xl overflow-hidden aspect-square">
              <img src={src} alt={`룩북 ${i + 2}`} className="w-full h-full object-cover" />
            </div>
          ))}
        </div>
      </div>

      {/* Desktop */}
      <div className="hidden lg:grid lg:grid-cols-4 lg:grid-rows-2 lg:gap-3 lg:max-h-[420px] mt-4">
        <div className="col-span-2 row-span-2 rounded-2xl overflow-hidden">
          <img src={images?.[0]} alt="룩북 대표" className="w-full h-full object-cover" />
        </div>
        {images?.slice(1).map((src, i) => (
          <div key={i} className="rounded-2xl overflow-hidden">
            <img src={src} alt={`룩북 ${i + 2}`} className="w-full h-full object-cover" />
          </div>
        ))}
      </div>
    </div>
  );
}